exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".CzL31qvhcOr0lB2q2WtDB{padding:20px 20px}._2Q95IMsSOUsP8YJyKCT79c{padding:20px 20px}.LvrcZNIyIW3_VMCsaNbJh{padding:20px;text-align:center}.rKa4u5c1sQHOw8d9V1zGy{font-style:italic;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"PinnedList": "CzL31qvhcOr0lB2q2WtDB",
	"IntroWidget": "_2Q95IMsSOUsP8YJyKCT79c",
	"resultsFooter": "LvrcZNIyIW3_VMCsaNbJh",
	"footerText": "rKa4u5c1sQHOw8d9V1zGy"
};